var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMfa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2963",
    "data-name": "Rectangle 2963",
    width: 24,
    height: 24,
    transform: "translate(1873.027 1430.042)",
    fill: "#003fb9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_mfa",
    transform: "translate(-1873.027 -1430.042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_223",
    "data-name": "Union 223",
    d: "M2.641,24a3.059,3.059,0,0,1-1.993-.977A3.038,3.038,0,0,1-.359,21V3A3.038,3.038,0,0,1,.648.977,3.06,3.06,0,0,1,2.641,0h9a3.064,3.064,0,0,1,1.993.977A3.042,3.042,0,0,1,14.641,3V21a3.042,3.042,0,0,1-1.007,2.023A3.063,3.063,0,0,1,11.641,24Zm3-2a1,1,0,1,0,1-1A1,1,0,0,0,5.641,22Zm-4-2h11V2h-11Zm5-5c-.077-.046-.179-.1-.3-.164l-.059-.031c-.923-.49-2.643-1.4-2.643-2.8V9a22.465,22.465,0,0,1,3-1l.008,0a34.891,34.891,0,0,1,3.992,1v3c0,1.451-1.843,2.4-2.729,2.857l-.022.012c-.1.05-.183.094-.25.131a1.492,1.492,0,0,1-.5.054A1.5,1.5,0,0,1,6.64,15Zm-.352-4.56a.33.33,0,0,0,.33.329h.189v.674a1.2,1.2,0,1,0,.661,0V9.185a.33.33,0,0,0-.661,0v.075H6.619a.329.329,0,1,0,0,.659h.189v.193H6.619A.33.33,0,0,0,6.288,10.44ZM6.6,12.6a.541.541,0,1,1,.541.539A.541.541,0,0,1,6.6,12.6Z",
    transform: "translate(1877.387 1430.042)",
    fill: "#003fb9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMfa);
export default __webpack_public_path__ + "static/media/ic_mfa.3bb308090252a9b2f97895c53379a745.svg";
export { ForwardRef as ReactComponent };